import { render, staticRenderFns } from "./CEventos.vue?vue&type=template&id=7b9f6f0e&"
import script from "./CEventos.vue?vue&type=script&lang=js&"
export * from "./CEventos.vue?vue&type=script&lang=js&"
import style0 from "./CEventos.vue?vue&type=style&index=0&id=7b9f6f0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports